import React, { useEffect, useState } from "react";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import "../css/AdminCollections.css";
import Footer from "../components/Footer";
import * as API from "../services/API";
import Icon from "../util/Icon";

function AdhesionAdmin(){
	const [adhesionList, setAdhesionList] = useState([]);
	useEffect(() => {
		API.getAllAdhesionRequest(
			(response)=>{
				setAdhesionList(response.data);
			},
			()=>{
			}
			)
		},
		[]
	);
    let handleDelete = (index) =>{
        API.removeAdhesionByIdRequest(index,
			(response)=>{
				API.getAllAdhesionRequest(
        (response)=>{
          setAdhesionList(response.data);
        },
        ()=>{
        }
        )
			},
			()=>{
			}
		)
    }

return (
  <>
      <div className="admin-collection-page">
        <HeaderHomeAdmin />

        <main className="container py-5">
          <section className="admin-collection-hero">
            <div>
              <span className="admin-collection-eyebrow">Gestion des contacts</span>
              <h1>Demandes d'adhésion</h1>
              <p>Retrouvez les coordonnées des personnes souhaitant rejoindre l'association.</p>
            </div>
            <div className="admin-collection-count" aria-label={`${adhesionList.length} demandes`}>
              <strong>{adhesionList.length}</strong>
              <span>{adhesionList.length > 1 ? "demandes" : "demande"}</span>
            </div>
          </section>

          {adhesionList.length === 0 ? (
            <div className="admin-collection-empty">
              <span className="admin-collection-empty-icon">
                <Icon icon="inbox" size="2xl" />
              </span>
              <h2>Aucune demande pour le moment</h2>
              <p>Les nouvelles demandes d'adhésion apparaîtront ici.</p>
            </div>
          ) : (
            <div className="admin-collection-grid">
              {adhesionList.map((demande, index) => (
                <article className="admin-person-card" key={demande._id || index}>
                  <div className="admin-person-card-header">
                    <div className="admin-person-avatar" aria-hidden="true">
                      {(demande.first_name?.[0] || "") + (demande.last_name?.[0] || "")}
                    </div>
                    <div>
                      <span className="admin-person-label">Nouvelle demande</span>
                      <h2>
                        {demande.first_name} {demande.last_name}
                      </h2>
                    </div>
                  </div>

                  <div className="admin-person-contacts">
                    <a
                      className={`admin-contact-row ${!demande.email ? "is-disabled" : ""}`}
                      href={demande.email ? `mailto:${demande.email}` : undefined}
                    >
                      <span className="admin-contact-icon"><Icon icon="envelope" /></span>
                      <span>
                        <small>Adresse e-mail</small>
                        <strong>{demande.email || "Non renseignée"}</strong>
                      </span>
                    </a>
                    <a
                      className={`admin-contact-row ${!demande.phone ? "is-disabled" : ""}`}
                      href={demande.phone ? `tel:${demande.phone}` : undefined}
                    >
                      <span className="admin-contact-icon"><Icon icon="phone" /></span>
                      <span>
                        <small>Téléphone</small>
                        <strong>{demande.phone || "Non renseigné"}</strong>
                      </span>
                    </a>
                  </div>

                  <div className="admin-card-footer">
                    <button
                      type="button"
                      className="admin-danger-button"
                      onClick={() => handleDelete(demande._id)}
                    >
                      <Icon icon="trash" />
                      Supprimer la demande
                    </button>
                  </div>
                </article>
              ))}
            </div>
          )}

        </main>
      </div>
      <Footer/>
    </>
);
}


export default AdhesionAdmin;
